import React from 'react';
import { render } from 'react-dom';
import numeral from 'numeral';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import Root from './containers/Root';
import * as analyticsMiddleware from './middleware/ga4-analytics';
import configureStore from './store/configureStore';
import { resetFilters, getFiltersConfig } from './actions/filters-actions';
import { checkHealthStatus } from './actions/error-actions';
import { logoutSuccess } from './actions/auth-actions';

import './assets/styles/fonts.css';
import './assets/styles/constants.css';
import './assets/styles/index.css';
import './assets/styles/index.print.css';
import './assets/styles';

numeral.register('locale', 'en-us', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  }
});

const store = configureStore();

const checkDownTimeWarning = async () => {
  try {
    await store.dispatch(checkHealthStatus());
  } catch (err) {
    console.log(err);
  }
};

const loadFilters = async () => {
  try {
    await store.dispatch(getFiltersConfig());
  } catch (err) {
    if (err.status === 401) {
      // this resets the login info in localStorage
      // and makes the app go to /login
      store.dispatch(logoutSuccess());
      store.dispatch(resetFilters());
    }
  }

  return null;
};

const init = async () => {
  await loadFilters();
  await checkDownTimeWarning();
  analyticsMiddleware.init();
  const appRoot = document.getElementById('root');
  appRoot.setAttribute('notranslate', true);
  render(<Root store={store} />, appRoot);
};

init();
